// Standard VAT rates per EU member state. Only the standard rate is ever
// used (professional services). Verified against the EU TEDB on 2026-09-25;
// the rollout checklist re-verifies before each production deploy.
// Entries are ordered by validFrom; standardRate picks the latest one in
// force on the given date so a scheduled change can be entered ahead of time.
const STANDARD_RATES = {
  AT: [{ validFrom: '2016-01-01', rate: 0.2 }],
  BE: [{ validFrom: '1996-01-01', rate: 0.21 }],
  BG: [{ validFrom: '2007-01-01', rate: 0.2 }],
  HR: [{ validFrom: '2012-03-01', rate: 0.25 }],
  CY: [{ validFrom: '2014-01-13', rate: 0.19 }],
  CZ: [{ validFrom: '2013-01-01', rate: 0.21 }],
  DK: [{ validFrom: '1992-01-01', rate: 0.25 }],
  EE: [
    { validFrom: '2009-07-01', rate: 0.2 },
    { validFrom: '2024-01-01', rate: 0.22 },
    { validFrom: '2025-07-01', rate: 0.24 },
  ],
  FI: [
    { validFrom: '2013-01-01', rate: 0.24 },
    { validFrom: '2024-09-01', rate: 0.255 },
  ],
  FR: [{ validFrom: '2014-01-01', rate: 0.2 }],
  DE: [{ validFrom: '2007-01-01', rate: 0.19 }],
  GR: [{ validFrom: '2016-06-01', rate: 0.24 }],
  HU: [{ validFrom: '2012-01-01', rate: 0.27 }],
  IE: [{ validFrom: '2012-01-01', rate: 0.23 }],
  IT: [{ validFrom: '2013-10-01', rate: 0.22 }],
  LV: [{ validFrom: '2012-07-01', rate: 0.21 }],
  LT: [{ validFrom: '2009-09-01', rate: 0.21 }],
  LU: [{ validFrom: '2024-01-01', rate: 0.17 }],
  MT: [{ validFrom: '2004-01-01', rate: 0.18 }],
  NL: [{ validFrom: '2012-10-01', rate: 0.21 }],
  PL: [{ validFrom: '2011-01-01', rate: 0.23 }],
  PT: [{ validFrom: '2011-01-01', rate: 0.23 }],
  RO: [
    { validFrom: '2017-01-01', rate: 0.19 },
    { validFrom: '2025-08-01', rate: 0.21 },
  ],
  SK: [
    { validFrom: '2011-01-01', rate: 0.2 },
    { validFrom: '2025-01-01', rate: 0.23 },
  ],
  SI: [{ validFrom: '2013-07-01', rate: 0.22 }],
  ES: [{ validFrom: '2012-09-01', rate: 0.21 }],
  SE: [{ validFrom: '1990-07-01', rate: 0.25 }],
};

const standardRate = (country, date = new Date()) => {
  const code =
    String(country || '').toUpperCase() === 'AX' ? 'FI' : String(country || '').toUpperCase();
  const entries = STANDARD_RATES[code];
  if (!entries) throw new Error(`No standard VAT rate for ${country}`);
  const iso = date.toISOString().slice(0, 10);
  const inForce = entries.filter(e => e.validFrom <= iso);
  const entry = inForce.length > 0 ? inForce[inForce.length - 1] : entries[0];
  return entry.rate;
};

module.exports = { STANDARD_RATES, standardRate };
